﻿import Grid2 from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import { createStyles, makeStyles } from "@mui/styles";
import type { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import { useEffect, useMemo, useRef, useState } from "react";
import CustomLoadingOverlay from "../../../../components/loaders/LazyLoading/LazyLoading";
import { useAssetDetailsContext } from "../../context/assetDetailsContext";
import { globalDefaultColDef } from "@setup/ag-grid/mesf-theme";

const useStyles = makeStyles((theme) =>
	createStyles({
		paper: {
			height: "100%",
			width: "100%",
			padding: 10,
		},
	}),
);

type CustomizedMenusProps = {
	isStatisticsLoading: boolean;
};

export default function Statistics({
	isStatisticsLoading,
}: CustomizedMenusProps) {
	const classes = useStyles();
	const gridRef = useRef<AgGridReact>(null);
	const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
	const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
	const {
		state: { statisticsRows },
	} = useAssetDetailsContext();

	const [columnDefs, setColumnDefs] = useState<ColDef[]>([
		{ field: "Name", headerName: "Name", flex: 9 },
		{ field: "Value", headerName: "N°", flex: 3 },
	]);

	const loadingOverlayComponent = useMemo<any>(() => {
		return CustomLoadingOverlay;
	}, []);

	return (
		<Paper elevation={1} className={classes.paper}>
			<Grid2 container style={{ height: "100%" }}>
				<Grid2 size={{ md: 12, xs: 12 }}>
					<div style={containerStyle}>
						<div style={gridStyle}>
							<AgGridReact
								ref={gridRef}
								rowData={statisticsRows}
								columnDefs={columnDefs}
								rowHeight={32}
								headerHeight={35}
								animateRows={true}
								loading={isStatisticsLoading}
								defaultColDef={globalDefaultColDef}
								loadingOverlayComponent={loadingOverlayComponent}
								suppressContextMenu={true}
							></AgGridReact>
						</div>
					</div>
				</Grid2>
			</Grid2>
		</Paper>
	);
}
